/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { get } from '../utils/httpRequests';
import Cookies from 'universal-cookie';
import { APIs } from '../utils/apis';
import {
  Form,
  Button,
  Card,
  Row,
  Col,
  message,
  Table,
  Steps,
  Select,
  Checkbox,
  Tag,
  Modal
} from 'antd';
import { commonFileUpload } from '../actions/sessionActions';
import JsonViewer from '../sharedComponent/JsonView';

const { Column } = Table;

const { Option } = Select;

const { Step } = Steps;

const steps = [
  {
    title: 'Enterprise',
    content: 'First-content'
  },
  {
    title: 'Simulation',
    content: 'Second-content'
  }
];

const Simulation = () => {
  const fileRef = useRef();
  const [current, setCurrent] = useState(0);
  const [enterprise, setEnterprise] = useState({
    list: [],
    isFetching: true,
    id: null,
    selected: {},
    sub_token: null
  });
  const [state, setState] = useState({
    skip_serviceability: false,
    ignore_ordered_lists: false,
    force_use_filter: false,
    modal: {
      title: '',
      data: {},
      visible: false
    },
    isSubmitting: false
  });

  const [simulationHistory, setSimulationHistory] = useState({
    list: [],
    isFetching: true
  });

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  useEffect(() => {
    setEnterprise({ ...enterprise, isFetching: true });
    const fetchAccess = get({ url: APIs.USER.SELF_ACCESS });
    const fetchEnterprises = get({ url: APIs.USER.ENTERPRISES });

    Promise.all([fetchAccess, fetchEnterprises])
      .then(([accessRes, entRes]) => {
        let enterprises = [];
        if (entRes?.data?.meta?.status === 200) {
          enterprises = entRes.data.result.list;
        }

        if (accessRes?.data?.meta?.status === 200) {
          const { accessToAll, enterpriseIds } =
            accessRes.data.result.list[0] || {};
          if (!accessToAll) {
            const allowed = enterpriseIds || [];
            enterprises = enterprises.filter(ent =>
              allowed.some(aid => Number(aid) === Number(ent.id))
            );
          }
        }

        setEnterprise({
          list: enterprises
            .sort((a, b) => a?.name?.localeCompare(b.name))
            .filter(enterprise => enterprise.is_active),
          isFetching: false,
          id: null,
          selected: {},
          sub_token: null
        });
      })
      .catch(() => {
        setEnterprise({
          list: [],
          isFetching: false,
          id: null,
          selected: {},
          sub_token: null
        });
      });
  }, []);

  useEffect(() => {
    if (current === 1 && enterprise.sub_token) {
      setSimulationHistory({ ...simulationHistory, isFetching: true });
      axios({
        url: `${APIs.SIMULATION.RUN}`,
        method: 'GET',
        headers: {
          Authorization: `Token ${enterprise.sub_token}`
        }
      }).then(response => {
        let list = [];
        if (response?.data?.meta?.status === 200) {
          list = response.data.result;
        }
        setSimulationHistory({
          list,
          isFetching: false
        });
      });
    }
  }, [enterprise.id, current === 1]);

  const handleEnterpriseChange = value => {
    const selectedEnterprise = enterprise.list.find(
      enterprise => enterprise.id === value
    );
    if (value) {
      const cookies = new Cookies();
      message.loading('Accessing enterprise...', 0);
      get({
        url: `${APIs.DASHBOARD_LOGIN}&enterprise_id=${value}`
      }).then(res => {
        if (res?.data?.result?.length > 0) {
          const userObj = res.data.result[0];
          if (userObj.sub_token) {
            message.destroy();
            setEnterprise({
              ...enterprise,
              id: value,
              selected: selectedEnterprise,
              sub_token: userObj.sub_token
            });
          } else {
            const current_user_id = cookies.get('user_id');
            axios({
              url: APIs.GENERATE_TOKEN,
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              data: {
                user_id: userObj.user_id,
                internal_user_id: current_user_id
              }
            })
              .then(tokenRes => {
                message.destroy();
                setEnterprise({
                  ...enterprise,
                  id: value,
                  selected: selectedEnterprise,
                  sub_token: tokenRes.data.token
                });
              })
              .catch(() => {
                message.destroy();
                message.error('Failed to generate token');
              });
          }
        } else {
          message.destroy();
          message.error('No users found for this enterprise');
        }
      });
    } else {
      setEnterprise({
        ...enterprise,
        id: value,
        selected: selectedEnterprise,
        sub_token: null
      });
    }
  };

  const openModal = id => {
    const simulation = simulationHistory?.list?.find(item => item.id === id);
    setState({
      ...state,
      modal: {
        ...state.modal,
        visible: true,
        title: 'Simulation Configuration',
        data: simulation
      }
    });
  };

  const onSubmit = () => {
    const file = fileRef.current.files[0];
    if (!file) {
      return message.error('Please select a file');
    }
    message.loading('Initiating request...');
    setState({ ...state, isSubmitting: true });
    const preUrlPrefix = `alerts-dashboard/simulation/weightage/${enterprise.id}/`;
    commonFileUpload(fileRef.current.files[0], preUrlPrefix, url => {
      axios({
        url: `${APIs.SIMULATION.CONFIG}`,
        method: 'POST',
        data: {
          weightage_file_link: url,
          simulation_configs: {
            skip_serviceability: state.skip_serviceability,
            ignore_ordered_lists: state.ignore_ordered_lists,
            force_use_filter: state.force_use_filter
          }
        },
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Token ${enterprise.sub_token}`
        }
      }).then(response => {
        setState({ ...state, isSubmitting: false });
        message.destroy();
        if (response?.data?.meta?.status === 200) {
          onReset();
          message.success('Configuration submitted successfully');
        } else {
          message.error('Failed to submit configuration');
        }
      });
    });
  };

  const onReset = () => {
    setState({
      ...state,
      skip_serviceability: false,
      ignore_ordered_lists: false,
      force_use_filter: false
    });
    fileRef.current.value = '';
  };

  const onViewConfigurations = () => {
    message.loading('Fetching configurations...', 0);
    axios({
      url: `${APIs.SIMULATION.CONFIG}`,
      method: 'GET',
      headers: {
        Authorization: `Token ${enterprise.sub_token}`
      }
    }).then(response => {
      message.destroy();
      if (response?.data?.meta?.status === 200) {
        message.success('Configurations fetched successfully', 2);
        setState({
          ...state,
          modal: {
            ...state.modal,
            visible: true,
            title: 'Simulation Configurations',
            data: response.data.result
          }
        });
      } else {
        message.error('Failed to fetch configurations', 2);
      }
    });
  };

  const handleCheckboxChange = e => {
    const { name, checked } = e.target;
    setState({ ...state, [name]: checked });
  };

  const handleOk = () => {
    setState({
      ...state,
      modal: {
        ...state.modal,
        visible: false
      }
    });
  };

  const onSimulationRun = () => {
    message.loading('Initiating request...');
    axios({
      url: `${APIs.SIMULATION.RUN}`,
      method: 'POST',
      headers: {
        Authorization: `Token ${enterprise.sub_token}`
      }
    }).then(response => {
      message.destroy();
      if (response?.data?.meta?.status === 200) {
        message.success(response?.data?.meta?.message);
      } else {
        message.error(response?.data?.meta?.message);
      }
    });
  };

  return (
    <>
      <Steps current={current} size="small" className="margin-bottom-20">
        {steps.map((item, index) => (
          <Step
            key={item.title}
            title={
              index === 0 && enterprise?.selected?.name
                ? `${item.title} (${enterprise.selected.name})`
                : item.title
            }
          />
        ))}
      </Steps>
      {current === 0 && (
        <Select
          showSearch
          style={{ width: '98%' }}
          placeholder="Select enterprise"
          optionFilterProp="children"
          value={enterprise.id ?? undefined}
          onChange={value => handleEnterpriseChange(value)}
          allowClear={true}
        >
          {enterprise.list.map((enterprise, i) => (
            <Option key={i} value={enterprise.id}>
              {enterprise.name}
            </Option>
          ))}
        </Select>
      )}
      {current === 1 && (
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Card title="Configuration">
              <Form>
                <Form.Item
                  label="Upload Weightage File"
                  className="d-inline-flex align-items-center"
                >
                  <input
                    className="d-inline-block"
                    type="file"
                    ref={fileRef}
                    name="weightage_file_link"
                    accept=".csv"
                  />
                </Form.Item>
                <Form.Item name="skip_serviceability">
                  <Checkbox
                    name="skip_serviceability"
                    value={state.skip_serviceability}
                    onChange={handleCheckboxChange}
                    checked={state.skip_serviceability}
                  >
                    Skip Serviceability
                  </Checkbox>

                  <Checkbox
                    name="ignore_ordered_lists"
                    value={state.ignore_ordered_lists}
                    onChange={handleCheckboxChange}
                    checked={state.ignore_ordered_lists}
                  >
                    Ignore Ordered Lists
                  </Checkbox>
                  <Checkbox
                    name="force_use_filter"
                    value={state.force_use_filter}
                    onChange={handleCheckboxChange}
                    checked={state.force_use_filter}
                  >
                    Force Filter
                  </Checkbox>
                </Form.Item>

                <Form.Item className="margin-top-20 margin-bottom-0">
                  <Button
                    type="ghost"
                    htmlType="reset"
                    onClick={onReset}
                    style={{ marginRight: '20px' }}
                    disabled={state.isSubmitting}
                  >
                    Reset
                  </Button>
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={onSubmit}
                    disabled={state.isSubmitting}
                    loading={state.isSubmitting}
                  >
                    Submit Configuration
                  </Button>
                  <Button
                    type="ghost"
                    htmlType="reset"
                    onClick={onViewConfigurations}
                    style={{ marginLeft: '20px' }}
                  >
                    View Configurations
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Col>
          <Col span={24} className="margin-top-20">
            <Card
              title="History"
              extra={
                <Button type="primary" onClick={onSimulationRun}>
                  Run Simulation
                </Button>
              }
            >
              <Table
                dataSource={simulationHistory.list}
                size="middle"
                pagination={false}
              >
                <Column title="Simulation ID" dataIndex="id" key="id" />
                <Column
                  title="Created At"
                  dataIndex="created_at"
                  key="created_at"
                />
                <Column
                  title="Status"
                  dataIndex="status"
                  key="status"
                  render={status => (
                    <span>
                      <Tag
                        color={
                          status === 'FAILED'
                            ? 'red'
                            : status === 'RUNNING_SIMULATION'
                            ? 'blue'
                            : status === 'SUCCESS'
                            ? 'green'
                            : 'purple'
                        }
                        key={status}
                      >
                        {status}
                      </Tag>
                    </span>
                  )}
                />
                <Column
                  title="Action"
                  key="action"
                  render={(text, record) => (
                    <Button type="link" onClick={() => openModal(record.id)}>
                      View
                    </Button>
                  )}
                />
              </Table>
            </Card>
          </Col>
        </Row>
      )}
      <div className="steps-action">
        {current < steps.length - 1 && (
          <Button
            type="primary"
            onClick={() => next()}
            disabled={!enterprise.sub_token}
          >
            Next
          </Button>
        )}
        {current > 0 && (
          <Button style={{ marginLeft: 8 }} onClick={() => prev()}>
            Previous
          </Button>
        )}
      </div>
      <Modal
        title={state.modal?.title}
        visible={state.modal?.visible}
        onOk={handleOk}
        width={800}
        cancelButtonProps={{ style: { display: 'none' } }}
        onCancel={handleOk}
      >
        <JsonViewer data={state.modal.data} />
      </Modal>
    </>
  );
};

export default Simulation;
